module.exports = __webpack_public_path__ + "img/2.40ffc14d.jpg";